define('models/timezone',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.Timezone = T1Model.extend({
    canCache: true,
    url: "timezones/",
    fixture: "-timezones"
  });
  return T1.Models.Timezone;
});
